import { render } from "./CreateLocation.vue?vue&type=template&id=61ccc4f6&scoped=true"
import script from "./CreateLocation.vue?vue&type=script&lang=js"
export * from "./CreateLocation.vue?vue&type=script&lang=js"

import "./CreateLocation.vue?vue&type=style&index=0&id=61ccc4f6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ccc4f6"]])

export default __exports__